<script>
    export default {
        props: {
            filter: {
                type: Object,
                default() {
                    return {}
                },
            },
            groupEdit: {
                type: Boolean,
                default: true,
            },
            groupBy: {
                type: String,
            },
            groupData: {
                type: String,
            },
            label: {
                type: String,
                default: '',
            },
        },
    }
</script>

<template>
    <bg-table view="re-details?for=Product&amp;id=${Id}" :label="label" path="product" object="Product"
              :group-by="groupBy"
              :group-data="groupData" :filter="filter" :state-view="true">

        <template v-slot="data">
            <bg-column :label="$t('Name')" sort="Name">{{ $root.translation(data.row.ProductI18ns).Name }}</bg-column>
            <bg-column-relation :label="$t('Application areas')" :collection="data.row" name="ApplicationArea"/>
            <bg-column-files v-for="(folder, index) in data.row.CollectionType.Folders" :key="index"
                             :label="$root.translation(folder.FolderI18ns, {}, $root.Storage.get('settings').interfaceLanguage).Name" :collection="data.row"
                             :type="folder.Shortcut"/>
        </template>

        <template v-slot:group="data">
            <bg-table-group span="5" :label="$root.translation(data.row.GroupI18ns).Name"
                            :view="(groupEdit ? 're-details?for=Group&amp;id=${Id}' : '')" :data="data"
                            :isParentEditAllowed="$root.isReadAllowed('Group')"/>
        </template>

    </bg-table>
</template>
